const BTN_BORDER_RADIUS = {
  square: '0px',
  slightlyrounded: '4px',
  rounded: '8px',
  circular: '100px'
};
const BTN_BORDER_WIDTH = {
  none: '0px',
  thin: '2px',
  thick: '4px'
};
const BTN_BOX_SHADOW = {
  'soft-shadow': `0.3px 0.5px 0.6px hsl(var(--p-btn-box-shadow-color) / 0.2),
  1.3px 2.5px 3px -1.4px hsl(var(--p-btn-box-shadow-color) / 0.18),
  5.2px 10.4px 12.5px -2.8px hsl(var(--p-btn-box-shadow-color) / 0.17)`,
  'soft-shadow-low': `0.3px 0.5px 0.7px hsl(var(--p-btn-box-shadow-color) / 0.2),
  1.3px 2.5px 5px -1.1px hsl(var(--p-btn-box-shadow-color) / 0.18)`,
  'soft-shadow-high': `0.3px 0.5px 0.7px hsl(var(--p-btn-box-shadow-color) / 0.19),
  2.7px 5.5px 6.9px -0.6px hsl(var(--p-btn-box-shadow-color) / 0.19),
  6.6px 13.2px 16.6px -1.2px hsl(var(--p-btn-box-shadow-color) / 0.19),
  14.5px 29px 36.5px -1.9px hsl(var(--p-btn-box-shadow-color) / 0.19)`,
  'hard-shadow': '4px 4px 0 var(--p-btn-box-shadow-color)',
  'hard-shadow-medium': '8px 8px 0 var(--p-btn-box-shadow-color)',
  'hard-shadow-high': '12px 12px 0 var(--p-btn-box-shadow-color)',
  '3d': '0 6px 0 var(--p-btn-box-shadow-color)',
  '3d-medium': '0 10px 0 var(--p-btn-box-shadow-color)',
  '3d-high': '0 14px 0 var(--p-btn-box-shadow-color)'
};
const BTN_BOX_SHADOW_SIZE = {
  'soft-shadow-high': '4px',
  'hard-shadow': '4px',
  'hard-shadow-medium': '8px',
  'hard-shadow-high': '12px',
  '3d': '6px',
  '3d-medium': '10px',
  '3d-high': '14px',
  offset: '2px'
};
export { BTN_BORDER_RADIUS, BTN_BORDER_WIDTH, BTN_BOX_SHADOW, BTN_BOX_SHADOW_SIZE };